import  { jwtServerInstance }  from '../index'
import qs from	'qs'

export const getAllServiceMoney = () => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/all',
        method:'post'
    })
}


export const getAllReviewServiceMoney = (taskClass) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/queryreview',
        method:'post',
        data: qs.stringify({
            taskClass:taskClass
        })
    })
}

//列表查询接口
export const getServiceMoney = (queryFrom) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/query',
        method:'post',
        data:qs.stringify({
            btsId:queryFrom.btsId,
            b2cTaskTypeId:queryFrom.b2cTaskTypeId,
            servicePrice:queryFrom.servicePrice,
            chargesPrice: queryFrom.chargesPrice
        })
    })
}

//更新sys_role的一条数据记录
export const updateServiceMoney = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/updateBatch',
        method:'post',
        data:roleForm
    })
}

//更新sys_role的一条数据记录
export const updateReviewServiceMoney = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/updatereview',
        method:'post',
        data:roleForm
    })
}

//新增一条sys_role数据记录
export const addServiceMoney = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/add',
        method:'post',
        data:roleForm
    })
}

//新增一条sys_role数据记录
export const addReviewServiceMoney = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/addreview',
        method:'post',
        data:roleForm
    })
}

//删除一条sys_role数据记录
export const deleteServiceMoney = (id) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/delete',
        method:'post',
        data:qs.stringify({
            id:id
        })
    })
}

//删除一条sys_role数据记录
export const deleteReviewServiceMoney = (id) => {
    return jwtServerInstance.request({
        url:'/b2cservicemoney/deletereview',
        method:'post',
        data:qs.stringify({
            id:id
        })
    })
}
